module.exports = __webpack_public_path__ + "static/frictionless-37dad1a7b08af537c9a2520eb0ac41fe.jpg";